import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import store from '../store/'
import {Message} from 'element-ui';
/*****响应统一处理****/
let responseArr=[function (data) {
    let jsonData=null;
    try{
        jsonData=JSON.parse(data);
    }catch(err){
        jsonData=data;
    }
    // M0401 标识登录失效；
	// M0401 ：被踢掉 token失效 两种状态，现把 token失效单独增加状态码 M0402展示。 2022.01.05
    if(jsonData.state || jsonData.status){
        if(jsonData.state=="M0401" || jsonData.state == "M0402" || jsonData.state=="401" || jsonData.status=="M0401" || jsonData.status=="401" || jsonData.status == "M0402"){
            // Message({
            //     type: 'warning',
            //     message:jsonData.msg
            // });
            store.commit('setToken',"");
            store.commit('setXsrfToken',"");
            // 因为href跳转，所有本地没有提示信息，测试地址有待确认
            setTimeout(() => {
                parent.location.href=JSON.parse(localStorage.getItem("config")).server.root.url ;
            }, 1000)
            return false;
        }
        //对M030*和M050*状态头提示
        if(jsonData.state && (jsonData.state.indexOf("M030")!=-1 || jsonData.state.indexOf("M040")!=-1 || jsonData.state.indexOf("M050")!=-1)){
            Message({
                type: 'warning',
                message:jsonData.msg
            });
        }
        if(jsonData.status && (jsonData.status.indexOf("M030")!=-1 || jsonData.status.indexOf("M040")!=-1 || jsonData.status.indexOf("M050")!=-1)){
            Message({
                type: 'warning',
                message:jsonData.msg
            });
        }
        
    }
    return jsonData;
    
}];
/*****请求拦截器操作*****/
let interceptorsRequest=(config)=>{
    config.headers["Authorization"] = store.getters.getToken || "";
    // YX-2743 多应用登录需求 增加各业务线（云信【YX-YL-WEB】  云租 云店 云保等） 标识 
	config.headers["clientType"] = "YX-YL-WEB";
    if(config.method.toLocaleLowerCase()=="post"){
        config.headers["Xsrf-Token"] = store.getters.getXsrfToken || "";
    }
    config.headers["namespace"] = window.namespace || '';
    return config;
}
let interceptorsResponse=(response)=>{
    if(response.headers['xsrf-token']){
        let timeStr=response.headers['xsrf-token'].substring(0,13);//时间戳
        if(store.state.main.xsrfToken){
            let storeTimeStr=store.state.main.xsrfToken.substring(0,13);
            if(timeStr>storeTimeStr){//新的时间戳>旧的时间戳 就替换掉
                store.commit('setXsrfToken',response.headers['xsrf-token']);
            }	
        }else{
            store.commit('setXsrfToken',response.headers['xsrf-token']);
        }
    }
    
    return response;
}
let errorRes=(error)=>{
    return Promise.reject(error);
}
/*****axios实例*****/
let axiosForm=axios.create({
    baseURL:"/",
    headers:{
        'Content-Type':'application/x-www-form-urlencoded',	//application/json;charset=UTF-8
    },
    transformRequest: [function (data) {
        return Qs.stringify(data);	//请求前对数据进行操作，仅支持PUT'，'POST'和'PATCH'
    }],
    transformResponse:responseArr,
});
let axiosJson=axios.create({
    baseURL:"/",
    headers:{
        'Content-Type':'application/json;charset=UTF-8',
    },
    transformResponse:responseArr,
});

let axiosFormataData=axios.create({
    baseURL:"/",
    headers:{
        'Content-Type':'multipart/form-data',
    },
    transformResponse:responseArr,
});

/****请求拦截器*****/
axiosForm.interceptors.request.use(interceptorsRequest,errorRes);
axiosJson.interceptors.request.use(interceptorsRequest,errorRes);
axiosFormataData.interceptors.request.use(interceptorsRequest,errorRes);

/*****响应拦截器*****/
axiosForm.interceptors.response.use(interceptorsResponse,errorRes);
axiosJson.interceptors.response.use(interceptorsResponse,errorRes);
axiosFormataData.interceptors.response.use(interceptorsResponse,errorRes);

Vue.prototype.axios = axios;
Vue.prototype.$axios = axiosForm;
Vue.prototype.$axiosJson = axiosJson;
Vue.prototype.$axiosFormataData = axiosFormataData;


export default axiosForm